import { render, staticRenderFns } from "./workspace-question-set-detail.vue?vue&type=template&id=0dcd94d6&scoped=true&"
import script from "./workspace-question-set-detail.vue?vue&type=script&lang=js&"
export * from "./workspace-question-set-detail.vue?vue&type=script&lang=js&"
import style0 from "./workspace-question-set-detail.vue?vue&type=style&index=0&id=0dcd94d6&lang=scss&scoped=true&"
import style1 from "./workspace-question-set-detail.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0dcd94d6",
  null
  
)

export default component.exports